import React from "react";

import Instagram from "assets/svg/footer/mobileInstagramLogo.svg";
import Facebook from "assets/svg/footer/mobileFacebookLogo.svg";
import Pinterest from "assets/svg/footer/mobilePinterestLogo.svg";
import Twitter from "assets/svg/footer/mobileTwitterLogo.svg";
import Linkedn from "assets/svg/footer/mobileLinkednLogo.svg";
import GooglePlay from "assets/svg/footer/mobileGooglePlayLogo.svg";
import AppStore from "assets/svg/footer/mobileAppStoreLogo.svg";
import AppGallery from "assets/svg/footer/mobileAppGalleryLogo.svg";

import styles from "./styles.module.css";

const SocialandDownloadLinksMobile = () => {
  return (
    <div className={styles.socialandDownloadLinksWrapper}>
      <hr className={styles.line} />
      <div className={styles.Wrapper}>
        <p className={styles.title}>Takip Et</p>
        <div className={styles.iconLayout}>
          <a href="https://www.instagram.com/emlakjet/" rel="nofollow">
            <Instagram />
          </a>
          <a href="https://www.facebook.com/Emlakjetcom//" rel="nofollow">
            <Facebook />
          </a>
          <a href="https://tr.pinterest.com/emlakjet/" rel="nofollow">
            <Pinterest />
          </a>
          <a href="https://x.com/emlakjet" rel="nofollow">
            <Twitter />
          </a>
          <a href="https://www.linkedin.com/company/emlakjet-com" rel="nofollow">
            <Linkedn />
          </a>
        </div>
      </div>
      <hr className={styles.line} />
      <div className={styles.Wrapper}>
        <p className={styles.title}>Uygulamayı İndir</p>
        <div className={styles.iconLayout}>
          <a
            href="https://play.google.com/store/apps/details?id=com.emlakjet.kurumsal.sekizbit"
            rel="nofollow"
            className={styles.DownloadLinks}
          >
            <GooglePlay />
            <span className={styles.text}>Google Play</span>
          </a>
          <a
            href="https://apps.apple.com/tr/app/emlakjet-emlak-ara-i-lan-ver/id1194656334?l=tr"
            rel="nofollow"
            className={styles.DownloadLinks}
          >
            <AppStore />
            <span className={styles.text}>App Store</span>
          </a>
          <a href="https://appgallery.huawei.com/app/C101850135" rel="nofollow" className={styles.DownloadLinks}>
            <AppGallery />
            <span className={styles.text}>AppGallery</span>
          </a>
        </div>
      </div>
      <hr className={styles.line} />
    </div>
  );
};
export default SocialandDownloadLinksMobile;
